import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=552401d4&scoped=true"
import script from "./IconInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IconInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552401d4",
  null
  
)

export default component.exports